import React from 'react';
import {Button} from "reactstrap";
import {EditElementModal} from "../../EditElementModal";
import {ImportFromCSVModalForm} from "./ImportFromCSVModalForm";
import { withTranslation } from 'react-i18next';

export const CAMPAIGN_NAME = "CampaignName";
export const ADGROUP_NAME = "AdgroupName";
export const CAMPAIGN_ID = "CampaignId";
export const ADGROUP_ID = "AdgroupId";
export const BUDGET = "Budget";
export const ENTITY_IMPORTING_CAMPAIGN = "campaign";
export const ENTITY_IMPORTING_ADGROUP = "adgroup";

class ImportFromCSVModalComponent extends EditElementModal {

    DATA_BY_FIELD = {
        [CAMPAIGN_NAME]: {
            aliases: ["campaign name", "nombre campaña", "nombre de campaña", "campaignname", "campaña"]
        },
        [CAMPAIGN_ID]: {
            aliases: ["campaign id", "id de campaña", "campaignid"]
        },
        [ADGROUP_NAME]: {
            aliases: ["adgroup name", "adgroup", "nombre grupo de anuncios", "adset", "adgroupname", "grupo de anuncios"]
        },
        [ADGROUP_ID]: {
            aliases: ["adgroup id", "adset id", "adgroupid"]
        },
        [BUDGET]: {
            aliases: ["budget", "campaign budget", "campaignbudget", "campaignid", "presupuesto"]
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            importErrorText: null,
        };
    }

    isItemsConfigurationMode() {
        return (this.props.campaignsConfigurationId !== null && this.props.campaignsConfigurationId !== undefined);
    }

    parseCSV(csv) {
        const lines = csv.split('\n');
        const result = [];
        const headers = lines[0].split(',');

        for (let i = 1; i < lines.length; i++) {
            const obj = {};
            const currentLine = lines[i].match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);

            for (let j = 0; j < headers.length; j++) {
                // Remove quotes if they exist
                obj[headers[j]] = currentLine[j].replace(/(^"|"$)/g, '');
            }
            result.push(obj);
        }

        return result;
    }


    convertJsonToImportableJson(jsonData) {
        // Convierte los key en CampaignName, CampaignId, AdgroupName, AdgroupId, Budget solo si los encuentra

        if(jsonData === undefined || jsonData === null || jsonData.length === 0)
        {
            const error = "Falta seleccionar un archivo CSV válido";
            this.setState({importErrorText: error});
            return null;
        }

        const columnMappings = this.getColumnMappings(jsonData);
        if(columnMappings[BUDGET] === undefined) {
            const error = 'No se encontró la columna "Budget"';
            this.setState({importErrorText: error});
            return null;
        }

        if (this.props.entityImporting === ENTITY_IMPORTING_CAMPAIGN && columnMappings[CAMPAIGN_ID] === undefined && columnMappings[CAMPAIGN_NAME] === undefined) {
            const error = "Debe incluir la columna CampaignName o CampaignId";
            this.setState({importErrorText: error});
            return null;
        }

        if (this.props.entityImporting === ENTITY_IMPORTING_ADGROUP && columnMappings[ADGROUP_ID] === undefined && columnMappings[ADGROUP_NAME] === undefined) {
            const error = "Debe incluir la columna AdgroupName o AdgroupId";
            this.setState({importErrorText: error});
            return null;
        }

        const importableJsonData = jsonData.map(rawJson => {
            const itemTranslated = {};
            for (const columnName in columnMappings) {
                const value = rawJson[columnMappings[columnName]].replace(/\r/g, '');
                if(columnName === BUDGET) {

                    const budgetNumber = this.returnNumberIfValid(value);
                    if(budgetNumber === null) {
                        const error = "Se ha encontrado un presupuesto inválido: "+value;
                        this.setState({importErrorText: error});
                        return null;
                    }
                    itemTranslated[columnName] = budgetNumber;
                } else {
                    itemTranslated[columnName] = value;
                }
            }
            return itemTranslated;
        });

        return importableJsonData.includes(null) ? null : importableJsonData;
    }

    returnNumberIfValid(aString) {
        // Use a regular expression to check if the string is a valid number
        const isValidNumber = /^\d*\.?\d+$/.test(aString); // This regex checks for a decimal number
        if (!isValidNumber)
            return null;

        return parseFloat(aString);
    }

    getColumnMappings(jsonData) {
        // Mapea las columnas
        const item = jsonData[0];
        const entries = Object.entries(item);
        const columnMappings = {};
        entries.forEach(([alias, value]) => {
            const columnKey = this.getColumnNameByAlias(alias.trim().toLowerCase())
            // Reconoce la columna
            if (columnKey !== null) {
                columnMappings[columnKey] = alias;
            }
        });

        return columnMappings;
    }

    getColumnNameByAlias(alias) {
        for (const columnName in this.DATA_BY_FIELD) {
            if(this.DATA_BY_FIELD[columnName].aliases.includes(alias)) {
                return columnName;
            }
        }

        return null;
    }

    handleFormSubmitted(dataSubmitted) {
        if(!dataSubmitted.csvFile) {
            this.setState({
                importErrorText: "Debe seleccionar un archivo CSV",
                jsonData: null
            });
            return null;
        }

        const reader = new FileReader();

        reader.onerror = (e) => {
            const error = "Se ha producido un error leyendo el archivo: "+e.target.error;
            this.setState({importErrorText: error});
        };

        reader.onload = (e) => {
            const content = e.target.result;
            const jsonData = this.parseCSV(content);

            const importableJsonData = this.convertJsonToImportableJson(jsonData);
            if(importableJsonData === null)
                return;

            dataSubmitted = {
                ...dataSubmitted,
                jsonData: importableJsonData
            };

            delete dataSubmitted.csvFile

            this.toggle();
            this.props.onFormSubmitted(dataSubmitted);

        };
        reader.readAsText(dataSubmitted.csvFile);
    }

    renderModalForm() {
        return <ImportFromCSVModalForm closeModal={this.toggle}
                                       onModified={this.handleFormSubmitted}
                                       importErrorText={this.state.importErrorText}
        />
    }

    renderButton() {
        const className = this.props.buttonClassName !== undefined ? this.props.buttonClassName : "btn -alt";
        const buttonText = this.props.buttonText !== undefined ? this.props.buttonText : "Importar";
        return <Button key="button" className={className} onClick={this.toggle}>{buttonText}</Button>;
    }

    renderModalHeaderText() {
        const { t } = this.props;
        if (this.isItemsConfigurationMode())
            if(this.props.EntityImporting === ENTITY_IMPORTING_CAMPAIGN)
                return t('modal.import_campaigns');
            else
                return t('modal.import_adgroups');
        else
            return t('modal.import_control_lines');
    }
}

export const ImportFromCSVModal = withTranslation()(ImportFromCSVModalComponent);
